import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { handleNumberCheck } from '../constants'
import InputRow from './InputRow'
import Loading from './Loading'
export default class Contact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      phoneNumberArray: [
        {
          phoneType: '',
          phoneCountry: '',
          phoneNumber: '',
          isPrimary: true,
          id: 0,
          phoneCode:''
        }
      ],
      phoneTypeData: [],
      loading: true,
      email: this.props.email,
      error: '',
      mouseOver: false,
      phoneFormats:[]

    }
    this.addMoreRows = this.addMoreRows.bind(this)
    this.phoneTypeUpdate = this.phoneTypeUpdate.bind(this)
    this.phoneCountryUpdate = this.phoneCountryUpdate.bind(this)
    this.phoneNumberUpdate = this.phoneNumberUpdate.bind(this)
  }

  componentDidMount() {
   
      fetch(`${process.env.REACT_APP_API_URL}/api/PersonalInfo/GetCountriesWithPhoneFormat`)
      .then(res => res.json())
      .then(res => {
        this.setState({phoneFormats:res})
      })
      .then(() => fetch(`${process.env.REACT_APP_API_URL}/api/ContactInformation/GetPhoneTypes`))
      .then(res => res.json())
      .then(res => {
        this.setState({ phoneTypeData: res, loading: false })
        if (res.length) {
          const phoneType = res.filter(res => res.value === 'Mobile')
          const phoneTypeId = phoneType && phoneType.length > 0 ? phoneType[0].Id : ''
          let propValue = []
          this.props.contactInformation.forEach((element, i) => {
            
        const countryCodess = this.state.phoneFormats.filter(elements => elements.Id === parseInt(element.CountryId))
        
            propValue.push({
              phoneType: element.PhoneType,
              phoneCountry: parseInt(element.CountryId),
              phoneNumber: element.PhoneNumber,
              isPrimary: element.IsPrimary,
              id: i - 1,
              phoneCode:countryCodess[0].value?'+'+countryCodess[0].value:''
            })
          })
          if (!propValue.length) propValue = null
          this.setState({
            phoneNumberArray: propValue || [{
              phoneType: phoneTypeId,
              phoneCountry: 50,//'',
              phoneNumber: '',
              isPrimary: '',
              id: 0,
              phoneCode:'+20'
            }]
          })
          if (!(propValue && propValue.length)) {
            this.props.getDefaultValue('Contact', phoneTypeId)
          }
        }
      })

  }

  addMoreRows() {
    const { phoneNumberArray, phoneTypeData } = this.state
    const length = phoneNumberArray.length
    const phoneType = phoneTypeData.filter(res => res.value === 'Mobile')
    const phoneTypeId = phoneType && phoneType.length > 0 ? phoneType[0].Id : ''
    if (phoneNumberArray[length - 1].phoneNumber !== '' /*&& phoneNumberArray[length - 1].phoneCountry !== ''*/ && phoneNumberArray[length - 1].phoneType !== '') {
      this.setState({
        phoneNumberArray: [...this.state.phoneNumberArray, {
          phoneType: phoneTypeId,
          phoneCountry: 50,
          phoneNumber: '',
          isPrimary: '',
          id: length,
          phoneCode:'+20'
        }
        ]
      })
    } else {
      alert('Please fill all required information')
    }
  }

  CheckRows() {
    const { phoneNumberArray, phoneTypeData } = this.state
    const length = phoneNumberArray.length
    const phoneType = phoneTypeData.filter(res => res.value === 'Mobile')
    const phoneTypeId = phoneType && phoneType.length > 0 ? phoneType[0].Id : ''
    if (phoneNumberArray[length - 1].phoneNumber !== '' && phoneNumberArray[length - 1].phoneType !== '') {
      return 1
    } else {
      alert('Please fill all required information')
      return 0
    }
  }

  phoneTypeUpdate(value, index) {
    const { phoneNumberArray } = this.state
    const phoneNumbers = []

    phoneNumberArray.forEach((element, index1) => {
      if (index1 === index) {
        element.phoneType = value
      }
      phoneNumbers.push(element)
    })
    this.setState({ phoneNumberArray: phoneNumbers })
    this.props.collectState('Contact', {
      phoneNumberArray: phoneNumbers,
      email: this.props.email
    })
  }

  phoneCountryUpdate(value, index) {

    const { phoneNumberArray,phoneFormats } = this.state
    const phoneNumbers = []
    phoneNumberArray.forEach((element, index1) => {
      if (index1 === index) {
        element.phoneCountry = value
        const countryCodess = phoneFormats.filter(elements => elements.Id === parseInt(value))
        element.phoneCode=countryCodess[0].value?'+'+countryCodess[0].value:''
      }
      

      phoneNumbers.push(element)
    })
    this.setState({ phoneNumberArray: phoneNumbers })
    this.props.collectState('Contact', {
      phoneNumberArray: phoneNumbers,
      email: this.props.email
    })
  }

  phoneNumberUpdate(value, index) {
    const { phoneNumberArray } = this.state
    if (handleNumberCheck(value) === 0) {
      const phoneNumbers = []
      phoneNumberArray.forEach((element, index1) => {
        if (index1 === index) {
          element.phoneNumber = value
        }
        phoneNumbers.push(element)
      })
      this.setState({ phoneNumberArray: phoneNumbers })
      this.props.collectState('Contact', {
        phoneNumberArray: phoneNumbers,
        email: this.props.email
      })
    } else {
      alert('Please Enter Numbers Only!')
    }
  }

  primaryUpdate(index) {
    const { phoneNumberArray } = this.state
    const phoneNumber = []
    phoneNumberArray.forEach((element, index1) => {
      if (index1 === index) {
        element.isPrimary = true
      } else {
        element.isPrimary = false
      }
      phoneNumber.push(element)
    })
    this.setState({ phoneNumberArray: phoneNumber })
    this.props.collectState('Contact', {
      phoneNumberArray: phoneNumber,
      email: this.props.email
    })
  }

  deleteRow(index) {
    const { phoneNumberArray } = this.state
    // eslint-disable-next-line prefer-const
    let phoneNumbers = []
    let count = 0
    phoneNumberArray.forEach((element, index1) => {
      if (index1 === index) {
        if (element.isPrimary) {
          count = 1
        }
      } else {
        phoneNumbers.push(element)
      }
    })
    if (count === 1) {
      phoneNumbers[0].isPrimary = true
    }
    this.setState({ phoneNumberArray: phoneNumbers })
    this.props.collectState('Contact', {
      phoneNumberArray: phoneNumbers,
      email: this.props.email
    })
  }

  render() {
    const validationError = this.props.error
    const { phoneNumberArray, loading, phoneTypeData, error } = this.state
    if (loading) {
      return (<Loading />)
    }

     const phoneNumbers = []
    phoneNumberArray.forEach((element, index) => { 
      if (phoneNumberArray.length === 1) {
        
        phoneNumbers.push(
          <tr key={element.id + ' ' + element.value}>
            <td className="hidden" style={{ position: 'relative', verticalAlign: 'top' }}>
              <select className="simple-select"
                value={element.phoneType}
                style={{ borderColor: validationError[index] ? validationError[index].phoneType ? 'red' : '' : '' }}
                onChange={(e) => {
                  this.phoneTypeUpdate(e.target.value, index)
                }}
              >
                { <option value={''} key={0 + 'phoneType'}>Select</option> }
                {phoneTypeData.map(element => {
                  return <option value={element.Id} key={element.Id + ' ' + element.value} >
                    {element.value}
                  </option>
                })}
              </select>
              <span style={{ color: 'red', marginLeft: 5, fontSize: 12, display: 'block' }}>{validationError[index] ? validationError[index].phoneType : ''}</span>
            </td>
            <td style={{ position: 'relative', verticalAlign: 'top' }}>
              <InputRow
                name="select"
                rowName="Country"
                value={element.phoneCountry}
                onChange={(val) =>
                  this.phoneCountryUpdate(val, index)
                }
                data={this.props.countryData}
                required="*"
                errMsg={validationError.phoneCountry ? validationError.phoneCountry : ''}
              />
            </td>
            <td style={{ position: 'relative', verticalAlign: 'top',width:20 }}>
              <InputRow
              style={{width:20 }}
                name="text"
                rowName="Country Code"
                value={element.phoneCode}
                disabled={true}
                data={this.props.countryData}
                required="*"
                //errMsg={validationError.phoneCountry ? validationError.phoneCountry : ''}
              />
            </td>

            

            <td style={{ position: 'relative', verticalAlign: 'top' }}>
              <InputRow
                name="text"
                rowName="Mobile Number"
                required="*"
                value={element.phoneNumber}
                onChange={(val) =>
                  this.phoneNumberUpdate(val, index)
                }
                
                errMsg={validationError.phoneNumber ? validationError.phoneNumber : ''}
                hover="Your Phone Number. رقم الهاتف"
              />
            </td>

          </tr>

        )
      } else if (phoneNumberArray.length > 1) {
        
        
        phoneNumbers.push(
          <tr key={element.id}>
            <td className="hidden" style={{ position: 'relative', verticalAlign: 'top' }}>
              <select className="simple-select"
                value={element.phoneType}
                style={{ borderColor: validationError[index] ? validationError[index].phoneType ? 'red' : '' : '' }}
                onChange={(val) => {
                  this.phoneTypeUpdate(val.target.value, index)
                }}
              >
                <option value={''} key={0 + 'phoneType'}>Select</option>
                {phoneTypeData.map(element => {
                  return <option value={element.Id} key={element.Id}>
                    {element.value}
                  </option>
                })}
              </select>
              <span style={{ color: 'red', marginLeft: 5, fontSize: 12, display: 'block' }}>{validationError[index] ? validationError[index].phoneType : ''}</span>
            </td>
            <td style={{ position: 'relative', verticalAlign: 'top' }}>
              <InputRow
                name="select"
                rowName="Country"
                value={element.phoneCountry}
                onChange={(val) =>
                  this.phoneCountryUpdate(val, index)
                }
                data={this.props.countryData}
                required="*"
                errMsg={validationError.phoneCountry ? validationError.phoneCountry : ''}
              />
            </td>
            <td style={{ position: 'relative', verticalAlign: 'top' }}>
              <InputRow
                name="text"
                rowName="Country Code"
                value={element.phoneCode}
                disabled={true}
                //data={this.props.countryData}
                required="*"
                //errMsg={validationError.phoneCountry ? validationError.phoneCountry : ''}
              />
            </td>
            <td style={{ position: 'relative', verticalAlign: 'top' }}>
              <InputRow
                name="text"
                rowName="Mobile Number"
                required="*"
                value={element.phoneNumber}
                onChange={(val) =>
                  this.phoneNumberUpdate(val, index)
                }
                errMsg={validationError.phoneNumber ? validationError.phoneNumber : ''}
                hover="Your Phone Number. رقم الهاتف"
              />
            </td>
            <td className="primary-td">
              <div className='primary-main-td-wrapper'>
                <div className='primary-wrapper'>
                <input
                  onChange={() => this.primaryUpdate(index)}
                  type="radio"
                  name="primary"
                  value={element.isPrimary}
                  checked={element.isPrimary} />
                  <span className='primary-txt'>Primary</span>
                  </div>
                {index === 0 ? null : <button className='save' onClick={this.deleteRow.bind(this, index)}><span>x</span></button>}
              </div>
            </td>
          </tr>

        )
      }
    })
    return (
      <div>
        <div>
          <p style={{ color: 'red' }}>{error}</p>
          <div>
            <div>
              <InputRow
                name="email"
                rowName="E-mail Address"
                value={this.props.email || ''}
                disabled={true}
                onChange={(val) => this.setState({ email: val.target.value })}
                required="*"
                hover="Your email address must contain both an @ symbol and a period (.). يجب أن يحتوي عنوان بريدك الإلكتروني على رمز @ وفترة (.)"
              />
            </div>
          </div>
          <p>Phone Numbers (Exclude Country Code)</p>
          <table className='contact-info-table'>
            <tbody>
              {phoneNumbers}
            </tbody>
          </table>
          <button
            className="save"
            onClick={() => {
              this.addMoreRows()
            }}
          >Add More</button>
        </div>

        <button className="save" onClick={() => { var result = this.CheckRows();if(result == 1) {this.props.onSave()}}}>Next</button>
      </div >
    )
  }
}
Contact.propTypes = {
  email: PropTypes.string.isRequired,
  countryData: PropTypes.array.isRequired,
  onSave: PropTypes.func.isRequired,
  incompleteApplicationId: PropTypes.number.isRequired,
  contactInformation: PropTypes.array,
  collectState: PropTypes.func,
  error: PropTypes.object,
  getDefaultValue: PropTypes.func

}
